export function parseAuthErrorMessage(error: string | null): string | null {
  if (!error) return null;
  try {
    const jsonStr = error.replace(/^[^{]*/, '');
    const data = JSON.parse(jsonStr);
    return data.error.message;
  } catch {
    return 'An unexpected error occurred. Please try again.';
  }
}
